<template>
  <v-data-table
    :headers="headers"
    :items="allTopics"
    :search="search"
    sort-by="value"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:body="{ items }">
      <tr v-for="item in items" :key="item.top">
        <td>
          <span>{{ item.topic }}</span>
        </td>
        <td>
          <atualValue :clientMQTT="clientMQTT" :subTopic="item.topic" ></atualValue>
        </td>
        <td>
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import { connectMQTT } from "@/services/mqtt/configuration";
import atualValue from "./value.vue";
export default {
  props: {
    topicValue: {
      type: Array
    }
  },
  components: {
    atualValue
  },
  data() {
    return {
      clientMQTT: connectMQTT(),
      headers: [
        { text: "Topic", align: "start", sortable: false, value: "topic" },
        { text: "Value", value: "value"},
        { text: "Action", sortable: false, value: "action" }
      ],
      allTopics: [],
      search: "",
      select: null,
      topic: ""
    };
  },
  
  watch: {
    topicValue(val) {
      let allTopics = [];
      val.forEach(element => {
        if(element.topic) {
          allTopics.push(element);
        } else {
          allTopics.push({ topic: element });
        }
      });
      this.allTopics = allTopics;
    }
  },
  methods: {
    deleteItem(item) {
      this.allTopics = this.allTopics.filter(e => {
        return item != e;
      });
      this.$emit("delItem", this.allTopics);
      this.clientMQTT.unsubscribe(item.topic)      
    }
  }
};
</script>